import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCapmoms4 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPMOMS4: TIdToPageConfigMap = {
  [PageIdStylioCapmoms4.AGE_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.AGE_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioCapmoms4.URGE_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.URGE_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms4.HAIR_COLOR_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.HAIR_COLOR_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.EYES_COLOR_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.EYES_COLOR_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.JEWELRY_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.JEWELRY_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.BODY_SHAPE_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.BODY_SHAPE_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.STYLIO_TO_HELP_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.STYLIO_TO_HELP_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.TALL_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.TALL_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.WEIGHT_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.WEIGHT_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.URGE_2_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.URGE_2_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms4.FEEL_ABOUT_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.FEEL_ABOUT_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.PERCENTAGE_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.PERCENTAGE_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.SHOPPING_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.SHOPPING_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.STYLE_MOST_MATTERS_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.STYLE_MOST_MATTERS_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.FAVORITE_COLORS_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.FAVORITE_COLORS_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.LIKE_OR_DISLIKE_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_11_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.LIKE_OR_DISLIKE_11_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_12_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.LIKE_OR_DISLIKE_12_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_13_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.LIKE_OR_DISLIKE_13_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_14_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.LIKE_OR_DISLIKE_14_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_15_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.LIKE_OR_DISLIKE_15_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_16_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.LIKE_OR_DISLIKE_16_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_17_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.LIKE_OR_DISLIKE_17_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_18_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.LIKE_OR_DISLIKE_18_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_19_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.LIKE_OR_DISLIKE_19_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.STYLES_FEEL_LIKE_YOU_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.STYLES_FEEL_LIKE_YOU_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.URGE_4_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.URGE_4_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms4.TIME_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.TIME_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.TYPICAL_DAY_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.TYPICAL_DAY_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.BRAND_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.BRAND_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.FIND_NEW_CLOTHES_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.FIND_NEW_CLOTHES_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.NOTHING_TO_WEAR_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.NOTHING_TO_WEAR_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.OLD_CLOTHES_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.OLD_CLOTHES_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.COMBINE_CLOTHES_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.COMBINE_CLOTHES_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.OPTIMIZE_BUDGET_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.OPTIMIZE_BUDGET_CAPMOMS4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms4.URGE_3_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.URGE_3_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms4.PREPARE_FLOW_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.PREPARE_FLOW_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms4.EMAIL_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.EMAIL_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms4.EMAIL_CONSENT_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.EMAIL_CONSENT_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms4.PRE_PAYWALL_OFFER_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.PRE_PAYWALL_OFFER_CAPMOMS4,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms4.SUBSCRIPTIONS_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.SUBSCRIPTIONS_CAPMOMS4,
  },
  [PageIdStylioCapmoms4.CANCEL_OFFER_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.CANCEL_OFFER_CAPMOMS4,
  },
  [PageIdStylioCapmoms4.SUB_UPSELL_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.SUB_UPSELL_CAPMOMS4,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapmoms4.UPSELL_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.UPSELL_CAPMOMS4,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapmoms4.DOWNLOAD_CAPMOMS4]: {
    id: PageIdStylioCapmoms4.DOWNLOAD_CAPMOMS4,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
